import { Box, Skeleton } from '@mui/material';

export default function GraphSkeleton({
  animation = 'wave',
}: {
  animation?: 'pulse' | 'wave' | false;
}) {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'center',
          width: '70%',
          height: '90%',
          gap: '2rem',
        }}
      >
        <Skeleton
          variant="rectangular"
          width="10%"
          height="70%"
          animation={animation}
        />
        <Skeleton
          variant="rectangular"
          width="10%"
          height="50%"
          animation={animation}
        />
        <Skeleton
          variant="rectangular"
          width="10%"
          height="80%"
          animation={animation}
        />
        <Skeleton
          variant="rectangular"
          width="10%"
          height="20%"
          animation={animation}
        />
        <Skeleton
          variant="rectangular"
          width="10%"
          height="40%"
          animation={animation}
        />
        <Skeleton
          variant="rectangular"
          width="10%"
          height="80%"
          animation={animation}
        />
        <Skeleton
          variant="rectangular"
          width="10%"
          height="30%"
          animation={animation}
        />
        <Skeleton
          variant="rectangular"
          width="10%"
          height="50%"
          animation={animation}
        />
      </Box>
    </Box>
  );
}
